import { Component, OnInit } from '@angular/core';
import { CmsService } from '../cms.service';
import { Title } from '@angular/platform-browser';
import * as PrismicDOM from 'prismic-dom';

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.css']
})
export class ProductsComponent implements OnInit {

  public content;

  public generateMarkup(data) {
    return PrismicDOM.RichText.asHtml(data);
  }

  constructor(private cms: CmsService, private titleService:Title) { }

  ngOnInit() {
    this.titleService.setTitle(`Products -- ThinSlabz® by Rosetta Stone Group`);
    this.cms.getProductsMain().subscribe((response) => {
      this.content = response;
      // console.log("Documents: ", response);

    
      // if (response.results && response.results.length > 0) {
      //   this.featuredPost = response.results[0];
      // }
    })
    //.catch(console.error);
  }

  
}



// WEBPACK FOOTER //
// /tmp/build_0264da94/src/app/products/products.component.ts